import { FC } from 'react';
import cn from 'classnames';

import classes from 'src/styles/_commonClasses.module.scss';
import { ColorTheme, CommonSize } from 'constants/enums';
import { capitalizeFirstLetter } from 'lib/text.service';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import styles from './ContentWithSubBlocks.module.scss';
import { SliderTitle, SliderView } from './SliderView';
import { CommonTitle, CommonView } from './CommonView';

import { IContentWithSubBlocks } from '../config/declarations';

const ContentWithSubBlocks: FC<IContentWithSubBlocks> = ({
  blocks,
  bgColor,
  extraData,
}) => {
  const [block] = blocks;
  const {
    colorTheme = ColorTheme.BLACK,
    verticalPadding = CommonSize.X_SMALL,
    view = 'slider',
  } = extraData || {};

  if (!block) {
    return null;
  }

  return (
    <section
      style={{ background: bgColor }}
      className={cn(
        styles.wrapper,
        styles[`wrapper${capitalizeFirstLetter(view)}`],
        classes[`themeColor${capitalizeFirstLetter(colorTheme)}`],
        classes[`sharedWrapperPaddingVertical${capitalizeFirstLetter(verticalPadding)}`],
      )}
    >
      <div className={cn(
        styles.content,
        {
          [styles.common]: view === 'common',
          [styles.slider]: view !== 'common',
        },
      )}
      >
        {view === 'common'
          ? <CommonTitle content={block?.richTitle} />
          : <SliderTitle content={block?.richTitle} />}
        {view === 'common' && <hr className={styles.divider} />}
        <div className={styles.statisticsWrapper}>
          {view === 'common'
            ? <CommonView block={block} />
            : <SliderView block={block} />}
        </div>
      </div>
    </section>
  );
};

export default ContentWithSubBlocks;
